import React, { useState, useEffect } from "react";
import { apiRoutes, apiRequest } from "../../services";
import {
  AreaContainer,
  Button,
  ButtonContainer,
  CirclesContainer,
  FormContainer,
  LoginContainer,
  LoginCTitle,
  LoginSubTitle,
  LoginTitle,
} from "./loginStyled";

export default function Login() {
  const [isLoading, setIsLoading] = useState(false);

  const getLoginScreen = async () => {
    setIsLoading(true);
    const [error, data] = await apiRequest({
      method: "get",
      url: apiRoutes["login"],
    });
    if (!error) {
      window.location.replace(data.url);
    }
    setIsLoading(false);
  };

  return (
    <LoginContainer>
      {isLoading ? (
        <>
          <AreaContainer>
            <CirclesContainer>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
            </CirclesContainer>
          </AreaContainer>
          <FormContainer>
            <LoginCTitle>
              PagerDuty Premium Services Report Marketplace
            </LoginCTitle>
            <LoginSubTitle>Provided for PD Gold Customers</LoginSubTitle>
            <ButtonContainer>
              <LoginSubTitle>Loading....</LoginSubTitle>
            </ButtonContainer>
          </FormContainer>
        </>
      ) : (
        <>
          <AreaContainer>
            <CirclesContainer>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
            </CirclesContainer>
          </AreaContainer>
          <FormContainer>
            <LoginCTitle>
              PagerDuty Premium Services Report Marketplace
            </LoginCTitle>
            <LoginSubTitle>Provided for PD Gold Customers</LoginSubTitle>
            <ButtonContainer>
              <Button onClick={() => getLoginScreen()}>
                <p>
                  Sign in with your <br />
                  PagerDuty Login
                </p>
              </Button>
            </ButtonContainer>
          </FormContainer>
        </>
      )}
    </LoginContainer>
  );
}
